{
  "pages": {
    "vendors": {
      "title": "Vendors",
      "tabs": {
        "vendorList": "Vendor List",
        "vendorContracts": "Vendor Contracts"
      },
      "subtitle": "Manage vendor relationships and contracts",
      "details": {
        "title": "Vendor details",
        "breadcrumbList": "List of Vendors",
        "loadError": "We could not load this vendor. Try again later."
      },
      "internalPortal": {
        "title": "Vendor Management"
      }
    },
    "vendorsPageHeader": {
      "bulkUpload": "Bulk Upload",
      "addVendor": "Add Vendor",
      "importTemplate": {
        "title": "Download template",
        "tooltip": "Download the template to import vendors"
      },
      "addVendorMenu": {
        "createNew": "Create new vendor"
      }
    }
  },
  "components": {
    "vendorDetailsHeader": {
      "overallSummary": "Overall summary",
      "changeStatus": "Change Status",
      "moreMenu": {
        "label": "More options"
      }
    },
    "vendorOverallSummaryDialog": {
      "findOrganization": "Find organization",
      "searchPlaceholder": "Type something",
      "overallSummaryOption": "Overall Summary (all organizations included)",
      "noData": {
        "withoutSearch": "No organizations found",
        "withSearch": "No organizations found matching your search"
      }
    },
    "vendorContacts": {
      "table": {
        "title": "Contacts",
        "columns": {
          "name": "Name",
          "jobTitle": "Job title",
          "email": "Email",
          "phone": "Phone",
          "status": "Status"
        }
      },
      "addContact": "Add Contact",
      "viewNote": "View note",
      "viewNoteDisabled": "No note to view",
      "editContact": "Edit contact",
      "dialog": {
        "title": {
          "add": "Add Contact",
          "edit": "Edit Contact"
        },
        "noteViewTitle": "Note",
        "noteEmpty": "No note for this contact."
      },
      "form": {
        "fields": {
          "name": "Name",
          "jobTitle": "Job title",
          "email": "Email",
          "phone": "Phone number",
          "note": "Note"
        },
        "success": {
          "create": "Contact created successfully.",
          "update": "Contact updated successfully."
        },
        "errors": {
          "save": "Could not save contact. Please try again."
        }
      },
      "combobox": {
        "placeholder": {
          "select": "Select point of contact"
        },
        "empty": {
          "title": "There are no POCs for this vendor yet.",
          "description": "Create a point of contact (POC) for this vendor. You can update the POC later."
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive"
        }
      }
    },
    "vendorDetailsOrganizationScopeInfoBar": {
      "title": "Results for {{organizationName}}",
      "subtitle": "All results displayed below are related to the {{organizationName}} organization."
    },
    "vendorDetailsSummaryCards": {
      "totalContracts": "Total Contracts",
      "totalContractValue": "Total Contract Value",
      "clientOrganizations": "Client Organizations",
      "subsidiaries": "Subsidiaries",
      "openTickets": "Open Tickets",
      "openTasks": "Open Tasks",
      "openAudits": "Open Audits"
    },
    "vendorsTable": {
      "columns": {
        "vendorName": "Vendor name",
        "spendAreas": "Spend areas",
        "vendorAccount": "Vendor account",
        "contacts": "Contacts",
        "audits": "Audits",
        "openTickets": "Open tickets",
        "openTasks": "Open tasks",
        "totalValue": "Total value",
        "totalContractValue": "Total contract value",
        "contractsName": "Contracts",
        "clients": "Clients",
        "primaryContact": "Primary contact",
        "status": "Status",
        "lastUpdated": "Last updated",
        "vendorCategory": "Category",
        "more": "More",
        "name": "Service provider name",
        "category": "Service category",
        "poc": {
          "label": "PoC",
          "details": "Details"
        },
        "link": "Link to a poc file/site",
        "contracts": {
          "label": "Contracts",
          "contracts_one": "{{count}} contract",
          "contracts_other": "{{count}} contracts"
        }
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "onHold": "On Hold"
      },
      "spendAreasOverflowTriggerAriaLabel": "{{count}} more spend areas — hover or focus to see all",
      "vendorAccountsOverflowTriggerAriaLabel": "{{count}} more vendor accounts — hover or focus to see all"
    },
    "vendorsFilters": {
      "category": "Service category"
    },
    "noData": {
      "title": "No vendors found",
      "description": "No vendors found"
    },
    "tabs": {
      "information": "Information",
      "contacts": "Contacts",
      "tickets": "Tickets",
      "tasks": "Tasks",
      "contracts": "Contracts",
      "relatedAudits": "Related Audits"
    },
    "information": {
      "basicInformation": "Basic information",
      "billPay": "BillPay",
      "billingAddress": "Billing address",
      "shippingAddress": "Shipping address",
      "dateOfCreation": "Date of creation",
      "vendorUrl": "Vendor URL",
      "portalUrl": "Portal URL",
      "emailInvoiceCapability": "Email Invoice Capability",
      "ediApiInvoiceCapability": "EDI/API Invoice Capability",
      "paymentMethodCardAccepted": "Payment Method Card Accepted",
      "cardFee": "Card Fee",
      "paymentMethodAchAccepted": "Payment Method ACH Accepted",
      "paymentRemittanceEmail": "Payment Remittance Email",
      "paymentRemittanceIdentifier": "Payment Remittance Identifier",
      "earlyPayDiscount": "Early Pay Discount",
      "paymentType": "Payment Type",
      "w9": "W9",
      "payeeName": "Payee Name",
      "bankName": "Bank Name",
      "routingNumber": "Routing Number",
      "bankAccountNumber": "Bank Account Number",
      "mailingAddress": "Mailing address"
    },
    "vendorBillPayFormDialog": {
      "success": "BillPay information updated successfully.",
      "saveError": "Could not save BillPay information. Please try again.",
      "tabs": {
        "mainDetails": "Main details",
        "bankDetails": "Bank details",
        "billingAddress": "Billing address",
        "mailingAddress": "Mailing address"
      },
      "fields": {
        "payeeName": "Payee Name",
        "bankName": "Bank Name",
        "routingNumber": "Routing Number",
        "bankAccountNumber": "Bank Account Number",
        "cardFeeType": "Card Fee Type",
        "cardFeeAmount": "Card Fee Amount ($)",
        "cardFeePercentage": "Card Fee Amount (%)",
        "vendorPayeeName": "Vendor Payee Name",
        "addressLine1": "Address Line 1",
        "addressLine2": "Address Line 2",
        "country": "Country",
        "state": "State",
        "city": "City",
        "zipCode": "Zip Code",
        "sameAsBillingAddress": "Same as billing address"
      },
      "options": {
        "cardFeeType": {
          "amount": "Amount ($)",
          "percentage": "Percentage (%)"
        }
      },
      "validation": {
        "invalidValue": "Invalid value",
        "percentageRange": "Percentage must be between 0 and 100",
        "maxDecimalPlaces": "Must have at most 2 decimal places",
        "routingNumberDigitsOnly": "Routing number must contain digits only",
        "routingNumberLength": "Routing number must be exactly 9 digits",
        "routingNumberChecksum": "Enter a valid ABA routing number",
        "bankAccountDigitsOnly": "Bank account number must contain digits only",
        "bankAccountLength": "Bank account number must be between 4 and 17 digits",
        "bankAccountObviouslyFake": "Enter a valid bank account number"
      }
    },
    "vendorFormDialog": {
      "new": "Add Vendor",
      "edit": "Edit Vendor",
      "fields": {
        "vendorName": "Vendor name",
        "category": "Category",
        "status": "Status",
        "vendorUrl": "Vendor URL",
        "portalUrl": "Portal URL",
        "assignee": "Assignee",
        "billingAddress": "Billing address",
        "shippingAddress": "Shipping address",
        "note": "Note"
      }
    },
    "vendorsUploadDialog": {
      "title": "Upload new vendors",
      "vendorfile": "Vendor file",
      "description": "Upload vendors from a CSV file",
      "uploadSuccess": "All {{count}} vendors uploaded successfully",
      "uploadPartial": "{{uploaded}} vendors uploaded successfully, {{invalid}} need corrections",
      "uploadError": "Failed to upload vendors"
    },
    "invalidVendorsImportDialog": {
      "title": "Some records have incorrect fields",
      "description": "Due to an issue with our external partners' systems, we were unable to retrieve some of the requested files ({{incorrect}} out of {{total}}). Please contact our team member.",
      "editIncorrectFields": "Edit incorrect fields",
      "uploadWithoutRecords": "Upload without those records",
      "requiredFieldsTooltip": "Please fill in all required fields (Vendor Name, Category, Status) before uploading"
    },
    "invalidVendorsImportTable": {
      "columns": {
        "vendorName": "Vendor Name",
        "vendorUrl": "Vendor URL",
        "portalUrl": "Portal URL",
        "category": "Category",
        "status": "Status",
        "billingAddress": "Billing Address",
        "mailingAddress": "Mailing Address"
      },
      "incorrect": "Incorrect",
      "editIncorrectFields": "Edit incorrect fields"
    },
    "noFilteredResults": {
      "title": "No matching vendors",
      "description": "Try adjusting or clearing filters."
    },
    "pointOfContact": {
      "serviceProvider": "Service provider"
    },
    "contracts": {
      "title": "{{vendorName}}: Contracts",
      "noData": {
        "title": "No contracts",
        "description": "No contracts have been added yet"
      },
      "columns": {
        "documentName": "Document name",
        "name": "Name",
        "client": "Client",
        "category": "Category",
        "annualValue": "Annual value",
        "uploadedBy": "Uploaded by",
        "stage": "Stage",
        "uploadedDate": "Uploaded date",
        "contractId": "Contract ID",
        "negotationNumber": "Negotation #",
        "propertyName": "Property Name",
        "vendorName": "Vendor",
        "isVetted": "Is Vetted",
        "effectiveDate": "Effective Date",
        "validFrom": "Valid from",
        "validTo": "Valid to",
        "contractStatus": "Contract Status"
      },
      "stage": {
        "signed": "Signed"
      },
      "pdfModal": {
        "errorMessage": "An error occurred while downloading the contract.",
        "errorDescription": "There was an error downloading the contract. Please try again later.",
        "iframeTitle": "Contract PDF",
        "disabledTooltip": "No contract file available",
        "error": {
          "title": "Failed to load contract",
          "message": "An error occurred while loading the contract. Please try again later."
        }
      },
      "contractStatus": {
        "archived": "Archived",
        "billProcessingOnly": "Bill Processing Only",
        "fullyExecuted": "Fully Executed"
      }
    }
  },
  "enums": {
    "vendorStatus": {
      "active": "Active",
      "inactive": "Inactive",
      "onHold": "On Hold"
    },
    "billPayPaymentType": {
      "ach": "ACH",
      "cc": "CC",
      "check": "Check"
    },
    "paymentRemittanceIdentifier": {
      "invoice_number": "Invoice Number",
      "account_number": "Account Number"
    }
  }
}
